import { render, staticRenderFns } from "./MainteOutbox.vue?vue&type=template&id=2915d3f9"
import script from "./MainteOutbox.vue?vue&type=script&lang=js"
export * from "./MainteOutbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports